/**
 * Labels for the Horoscope PDF document in English and Tamil.
 * Reuses locale keys where possible; adds PDF-specific labels.
 *
 * @module pdfLabels
 */

const enLabels = {
  title: 'Horoscope',
  subtitle: 'Vedic Birth Chart Report',
  generatedBy: 'Generated by JyotishSastra',

  // Birth details
  birthDetailsTitle: 'Birth Details',
  name: 'Name',
  gender: 'Gender',
  dateOfBirth: 'Date of Birth',
  timeOfBirth: 'Time of Birth',
  placeOfBirth: 'Place of Birth',
  ayanamsa: 'Ayanamsa',

  // Planet table
  planetTableTitle: 'Planet Positions',
  planet: 'Planet',
  sign: 'Sign',
  degree: 'Degree',
  nakshatra: 'Nakshatra',
  pada: 'Pada',
  navamsa: 'Navamsa',
  retrograde: 'Retro',

  // Rasi chart
  rasiChartTitle: 'Rasi Chart',
  house: 'House',

  // Dasha
  dashaTitle: 'Vimshottari Dasha',
  currentlyRunning: 'Currently Running',
  mahadasha: 'Mahadasha',
  antardasha: 'Antardasha',
  pratyantdasha: 'Pratyantdasha',
  dashaLord: 'Lord',
  dashaDuration: 'Duration',
  dashaStart: 'Start',
  dashaEnd: 'End',
  birthDashaLord: 'Birth Dasha Lord',
  balanceAtBirth: 'Balance at Birth',
  mahadashaPeriods: 'Mahadasha Periods',

  // Yogas
  yogasTitle: 'Yogas',
  yogaName: 'Yoga',
  yogaStrength: 'Strength',
  yogaDescription: 'Description',
  yogaPlanets: 'Planets',
  noYogas: 'No significant yogas detected.',

  // Doshas
  doshasTitle: 'Doshas',
  doshaName: 'Dosha',
  doshaStatus: 'Status',
  doshaSeverity: 'Severity',
  doshaPresent: 'Present',
  doshaNotPresent: 'Not Present',
  doshaRemedies: 'Remedies',
  doshaCancellations: 'Cancellations',

  // Duration units
  yrsUnit: 'Y',
  monthsUnit: 'M',
  daysUnit: 'D',

  // Planets
  planets: {
    Sun: 'Sun', Moon: 'Moon', Mars: 'Mars', Mercury: 'Mercury',
    Jupiter: 'Jupiter', Venus: 'Venus', Saturn: 'Saturn',
    Rahu: 'Rahu', Ketu: 'Ketu', Ascendant: 'Ascendant',
  },

  // Signs
  signs: {
    Aries: 'Aries', Taurus: 'Taurus', Gemini: 'Gemini', Cancer: 'Cancer',
    Leo: 'Leo', Virgo: 'Virgo', Libra: 'Libra', Scorpio: 'Scorpio',
    Sagittarius: 'Sagittarius', Capricorn: 'Capricorn', Aquarius: 'Aquarius', Pisces: 'Pisces',
  },
};

const taLabels = {
  title: 'ஜாதகம்',
  subtitle: 'வேத ஜாதக அறிக்கை',
  generatedBy: 'ஜோதிஷ்சாஸ்திரா மூலம் உருவாக்கப்பட்டது',

  // Birth details
  birthDetailsTitle: 'பிறப்பு விவரங்கள்',
  name: 'பெயர்',
  gender: 'பாலினம்',
  dateOfBirth: 'பிறந்த தேதி',
  timeOfBirth: 'பிறந்த நேரம்',
  placeOfBirth: 'பிறந்த இடம்',
  ayanamsa: 'அயனாம்சம்',

  // Planet table
  planetTableTitle: 'கிரக நிலைகள்',
  planet: 'கிரகம்',
  sign: 'ராசி',
  degree: 'பாகை',
  nakshatra: 'நட்சத்திரம்',
  pada: 'பாதம்',
  navamsa: 'நவாம்சம்',
  retrograde: 'வக்ர',

  // Rasi chart
  rasiChartTitle: 'ராசி சக்கரம்',
  house: 'வீடு',

  // Dasha
  dashaTitle: 'விம்சோத்தரி தசா',
  currentlyRunning: 'தற்போது நடப்பு',
  mahadasha: 'மகா தசா',
  antardasha: 'புக்தி',
  pratyantdasha: 'அந்தரா',
  dashaLord: 'அதிபதி',
  dashaDuration: 'கால அளவு',
  dashaStart: 'தொடக்கம்',
  dashaEnd: 'முடிவு',
  birthDashaLord: 'பிறப்பு தசா அதிபதி',
  balanceAtBirth: 'பிறப்பில் மீதம்',
  mahadashaPeriods: 'மகா தசா காலங்கள்',

  // Yogas
  yogasTitle: 'யோகங்கள்',
  yogaName: 'யோகம்',
  yogaStrength: 'வலிமை',
  yogaDescription: 'விவரம்',
  yogaPlanets: 'கிரகங்கள்',
  noYogas: 'குறிப்பிடத்தக்க யோகங்கள் இல்லை.',

  // Doshas
  doshasTitle: 'தோஷங்கள்',
  doshaName: 'தோஷம்',
  doshaStatus: 'நிலை',
  doshaSeverity: 'தீவிரம்',
  doshaPresent: 'உள்ளது',
  doshaNotPresent: 'இல்லை',
  doshaRemedies: 'பரிகாரங்கள்',
  doshaCancellations: 'ரத்து',

  // Duration units
  yrsUnit: 'ஆ',
  monthsUnit: 'மா',
  daysUnit: 'நா',

  // Planets
  planets: {
    Sun: 'சூரியன்', Moon: 'சந்திரன்', Mars: 'செவ்வாய்', Mercury: 'புதன்',
    Jupiter: 'குரு', Venus: 'சுக்கிரன்', Saturn: 'சனி',
    Rahu: 'ராகு', Ketu: 'கேது', Ascendant: 'லக்னம்',
  },

  // Signs
  signs: {
    Aries: 'மேஷம்', Taurus: 'ரிஷபம்', Gemini: 'மிதுனம்', Cancer: 'கடகம்',
    Leo: 'சிம்மம்', Virgo: 'கன்னி', Libra: 'துலாம்', Scorpio: 'விருச்சிகம்',
    Sagittarius: 'தனுசு', Capricorn: 'மகரம்', Aquarius: 'கும்பம்', Pisces: 'மீனம்',
  },
};

/**
 * Get PDF labels for the given language.
 * @param {string} lang - 'en' or 'ta'
 * @returns {Object} Label set
 */
export const getPdfLabels = (lang) => {
  if (lang === 'ta') return taLabels;
  return enLabels;
};
